<template>
  <div>
    <organism-credential
      v-if="!isLoading"
      :communityListCount="communityListCount"
      :communityList="communityList"
      :credentialList="credentialList"
      :credentialListCount="credentialListCount"
      :modalId="modalId"
      :communityDetail="communityDetail"
      :credentialDetail="credentialDetail"
      @communityCurrentPageChange="getCommunityListFromApi"
      @credentialCurrentPageChange="getCredentialListFromApi"
      @clickButtonAddCommunity="clickButtonAddCommunity"
      @clickButtonAddCredential="clickButtonAddCredential"
      @clickCommunityRow="getCommunityByIdFromApi"
      @clickCredentialRow="getCredentialByIdFromApi"
      @editCommunity="editCommunityByApi"
      @editCredential="editCredentialByApi"
      @deleteCommunityById="deleteCommunityByIdByApi"
      @deleteCredentialById="deleteCredentialByIdByApi"
    ></organism-credential>

    <!-- ADD CREDENTIAL START -->
    <section name="add-credential">
      <organism-add-credential
        :modalId="modalId"
        :communityDetail="communityDetail"
        @addCommunity="addCommunityByApi"
        @addCredential="addCredentialByApi"
      ></organism-add-credential>
    </section>
    <!-- ADD CREDENTIAL END -->
  </div>
</template>

<script>
import {
  addCredentials,
  getCredentialsList,
  getCredentialsById,
  updateCredentialsById,
  deleteCredentialsById,
} from "@/api/api-module4"
import mixins from "@/mixins"
import OrganismCredential from "@/components/organisms/networkConfigurationManagement/OrganismCredential.vue"
import OrganismAddCredential from "@/components/organisms/networkConfigurationManagement/credential/OrganismAddCredential.vue"

export default {
  name: "Credential",
  components: {
    OrganismCredential,
    OrganismAddCredential,
  },
  mixins: [mixins],
  data() {
    return {
      modalId: null,
      perPage: 10,

      // community
      communityListCount: 0,
      communityList: null,

      communityDetail: null,

      // credential
      credentialListCount: 0,
      credentialList: null,

      credentialDetail: null,
    }
  },
  computed: {
    isLoading() {
      return !this.communityList || !this.credentialList
    },
  },
  async created() {
    await this.getDataFromApi()
  },
  methods: {
    async getDataFromApi() {
      await this.getCommunityListFromApi()
      await this.getCredentialListFromApi()
    },

    /* COMMUNITY START */
    async getCommunityListFromApi(filter) {
      this.showLoading(true)
      this.communityList = []
      const baseFilter = {
        PageNumber: 1,
        PageSize: 5,
      }
      filter = filter ? { ...baseFilter, ...filter } : baseFilter
      // get data from api
      await getCredentialsList("snmp", filter)
        .then((response) => {
          this.communityListCount = response.totalCount
          response.data.forEach((snmp) => {
            this.communityList.push({
              id: snmp.credentialId,
              name: snmp.credentialName,
              description: snmp.credentialDescription,
              port: snmp.port,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    clickButtonAddCommunity() {
      this.openModal("credential__add-community")
    },

    async addCommunityByApi(addCommunity) {
      this.showLoading(true)
      await addCredentials("snmp", addCommunity)
        .then(async (snmp) => {
          if (snmp.status === "ok") {
            this.toastSuccess("SNMP Community added successfully")
            await this.getCommunityListFromApi()
          } else {
            this.toastError("SNMP Community added failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getCommunityByIdFromApi(id) {
      this.showLoading(true)
      await getCredentialsById("snmp", id)
        .then((snmp) => {
          this.communityDetail = {
            id: snmp.credentialId,
            name: snmp.credentialName,
            description: snmp.credentialDescription,
            port: snmp.port,
            communityString: snmp.communityString,
          }
        })
        .finally(() => this.showLoading(false))
      await this.openModal("credential__edit-community")
    },

    async editCommunityByApi(id, editCommunity) {
      this.showLoading(true)
      await updateCredentialsById("snmp", id, editCommunity)
        .then(async (snmp) => {
          if (snmp.status === "ok") {
            this.toastSuccess("SNMP Community updated successfully")
            await this.getCommunityListFromApi()
          } else {
            this.toastError("SNMP Community updated failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async deleteCommunityByIdByApi(id) {
      this.showLoading(true)
      await deleteCredentialsById("snmp", id)
        .then(async (snmp) => {
          if (snmp.status === "ok") {
            this.toastSuccess("SNMP Community deleted successfully")
            await this.getCommunityListFromApi()
          } else {
            this.toastError("SNMP Community deleted failed")
          }
        })
        .finally(() => this.showLoading(false))
    },
    /* COMMUNITY END */

    /* CREDENTIAL START */
    async getCredentialListFromApi(filter) {
      this.showLoading(true)
      this.credentialList = []
      const baseFilter = {
        PageNumber: 1,
        PageSize: 10,
      }
      filter = filter ? { ...baseFilter, ...filter } : baseFilter
      // get data from api
      await getCredentialsList("remote", filter)
        .then((response) => {
          this.credentialListCount = response.totalCount
          response.data.forEach((remote) => {
            this.credentialList.push({
              id: remote.credentialId,
              name: remote.credentialName,
              type: remote.credentialProtocol,
              description: remote.credentialDescription,
              port: remote.port,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    clickButtonAddCredential() {
      this.openModal("credential__add-credential")
    },

    async addCredentialByApi(addCredential) {
      this.showLoading(true)
      await addCredentials("remote", addCredential)
        .then(async (remote) => {
          if (remote.status === "ok") {
            this.toastSuccess("SSH Credential added successfully")
            await this.showLoading(true)
            await this.getCredentialListFromApi()
            await this.showLoading(false)
          } else {
            this.toastError("SSH Credential added failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getCredentialByIdFromApi(id) {
      this.showLoading(true)
      await getCredentialsById("remote", id)
        .then((remote) => {
          this.credentialDetail = {
            id: remote.credentialId,
            name: remote.credentialName,
            type: remote.credentialProtocol,
            description: remote.credentialDescription,
            port: remote.port,
            username: remote.username,
            password: null,
            prompt: remote.prompt,
            isEnableRequired: remote.enableRequired,
            enableCommand: remote.enableCommand,
            enablePrompt: remote.enablePrompt,
            enablePassword: null,
          }
        })
        .finally(() => this.showLoading(false))

      this.openModal("credential__edit-credential")
    },
    async editCredentialByApi(id, editCredential) {
      this.showLoading(true)
      await updateCredentialsById("remote", id, editCredential)
        .then(async (remote) => {
          if (remote.status === "ok") {
            this.toastSuccess("SSH Credential updated successfully")
            await this.getCredentialListFromApi()
          } else {
            this.toastError("SSH Credential updated failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async deleteCredentialByIdByApi(id) {
      this.showLoading(true)
      await deleteCredentialsById("remote", id)
        .then(async (remote) => {
          if (remote.status === "ok") {
            this.toastSuccess("SSH Credential deleted successfully")
            await this.getCredentialListFromApi()
          } else {
            this.toastError("SSH Credential deleted failed")
          }
        })
        .catch((error) => {
          this.toastError(error.response.data.ErrorMessage)
        })
        .finally(() => this.showLoading(false))
    },
    /* CREDENTIAL END */

    /* MODAL START */
    openModal(id) {
      if (this.modalId) this.closeModal()

      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },
    /* MODAL END */
  },
}
</script>

<style lang="scss" scoped></style>
